import { GameSessionPlayerStatus } from '@okletsplay/core/src/modules/game-session/enums';
import { TournamentBracketResult } from '@okletsplay/core/src/modules/tournament-bracket/enums';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },

  teamContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '&.revert': {
      flexDirection: 'row-reverse',

      [theme.breakpoints.down('x-xs')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(0),
      },
    },

    [theme.breakpoints.down('x-xs')]: {
      paddingRight: theme.spacing(1),
    },
  },

  textDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    paddingRight: theme.spacing(2.5),

    '&.revert': {
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(2.5),
      alignItems: 'start',
    },

    [theme.breakpoints.down('x-xs')]: {
      paddingRight: theme.spacing(1.5),

      '&.revert': {
        paddingRight: theme.spacing(0),
        paddingLeft: theme.spacing(1.5),
      },
    },
  },

  name: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'end',
    width: theme.spacing(15),
    cursor: 'default',

    '&.revert': {
      textAlign: 'start',
    },

    [theme.breakpoints.down('x-xs')]: {
      width: theme.spacing(12),
    },
  },

  [GameSessionPlayerStatus.Pending]: {
    '&:before': {
      content: '"Pending"',
      textTransform: 'capitalize',
      color: theme.palette.gameSession.statuses.pending,
    },
  },

  [GameSessionPlayerStatus.Joined]: {
    '&:before': {
      content: '"Joined"',
      textTransform: 'capitalize',
      color: theme.palette.gameSession.statuses.joined,
    },
  },

  [GameSessionPlayerStatus.Ready]: {
    '&:before': {
      content: '"Ready"',
      textTransform: 'capitalize',
      color: theme.palette.gameSession.statuses.ready,
    },
  },

  [GameSessionPlayerStatus.Left]: {
    '&:before': {
      content: '"Left"',
      textTransform: 'capitalize',
      color: theme.palette.gameSession.statuses.left,
    },
  },

  [TournamentBracketResult.Win]: {
    '&:before': {
      content: '"Win"',
      color: theme.palette.success.main,
    },
  },

  [TournamentBracketResult.Loss]: {
    '&:before': {
      content: '"Eliminated"',
      color: theme.palette.error.light,
    },
  },

  [TournamentBracketResult.Draw]: {
    '&:before': {
      content: '"Draw"',
      color: theme.palette.text.secondary,
    },
  },

  divider: {
    margin: 'auto',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    wordWrap: 'break-word',
    fontFamily: '"Noto Sans"',
    fontSize: theme.spacing(2.5),
    lineHeight: theme.spacing(2.5),
    letterSpacing: theme.spacing(0.25),
    padding: theme.spacing(0, 1.875),
  },

  scoreContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(1.5),

    [theme.breakpoints.up('x-xs')]: {
      paddingTop: theme.spacing(0),
      justifyContent: 'space-evenly',
      padding: theme.spacing(0, 1.875),
    },
  },

  score: {
    width: theme.spacing(4.25),
    textAlign: 'center',

    '&.MuiTypography-root': {
      wordWrap: 'break-word',
      fontFamily: '"Noto Sans"',
      fontSize: theme.spacing(2.5),
      lineHeight: theme.spacing(2.5),
    },

    [theme.breakpoints.up('x-xs')]: {
      width: 'auto',
    },
  },

  scoreDivider: {
    textAlign: 'center',
    width: theme.spacing(2),
  },
}));
